import { ComponentUserInfoVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (): Promise<ComponentUserInfoVO> => fetcher(`/api/user/userInfo`, 'GET', undefined)
